<template>
  <div>
    <!-- FILTER START -->
    <log-dash-activity :getFilterOnStart="true" @filterChange="changeFilter"></log-dash-activity>
    <!-- FILTER END -->

    <div class="bg-white box-content mt-3">
      <!-- FILTER START -->
      <div class="row align-items-center justify-content-between py-2 px-2">
        <h4 style="color: #9f9f9f; font-weight: 300">Log History Activity</h4>
        <div class="d-flex col-md-4 relative">
          <input type="text" class="form-control" v-model="filter.search" placeholder="Search"
            @keyup.enter="onSearchClick" />
          <button type="button" style="
              background: transparent;
              outline: none;
              border: none;
              position: absolute;
              right: 1rem;
              top: 0.375rem;
            " @click="onSearchClick">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.89279 5.44689C9.89279 7.8907 7.91169 9.8718 5.46788 9.8718C3.02407 9.8718 1.04297 7.8907 1.04297 5.44689C1.04297 3.00307 3.02407 1.02197 5.46788 1.02197C7.91169 1.02197 9.89279 3.00307 9.89279 5.44689Z"
                stroke="#9D9D9D" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M10.9998 10.9778L8.59375 8.57178" stroke="#9D9D9D" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </button>
        </div>
      </div>
      <!-- FILTER END -->
      <div class="mt-3 scan-history-table-wrapper">
        <div v-if="tableLoading" class="text-center mt-3 mb-3">
          <h4>Loading...</h4>
        </div>

        <div v-else style="overflow-x: auto; overflow-y: hidden">
          <table class="table scan-history-table" style="margin: 0">
            <thead>
              <tr>
                <th>User ID</th>
                <th>Username</th>
                <th>Menu</th>
                <th>Module</th>
                <th>Last Access</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in tableData" :key="index">
                <td>{{ row.user_id }}</td>
                <td>{{ row.username }}</td>
                <td>{{ row.menu }}</td>
                <td>{{ row.module }}</td>
                <td>{{ row.created_at }}</td>
              </tr>
              <tr v-if="!tableLoading && tableData.length === 0">
                <td colspan="5" class="text-center">No data available</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="row mt-3" v-if="!tableLoading && (tableData.length > 0 || maxPage > 0)">
          <div class="col-12 d-flex align-items-center justify-content-between flex-wrap">
            <div class="d-flex align-items-center">
              <span style="
                  margin-right: 8px;
                  margin-bottom: 0;
                  color: #a3a4a6;
                  font-size: 14px;
                ">
                View
              </span>
              <select id="items-per-page" v-model.number="limitPerPage" @change="onLimitChange"
                class="form-control form-control-sm" style="width: auto; display: inline-block; padding: 4px 8px"
                aria-label="Items per page">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
              <span style="
                  margin-left: 8px;
                  margin-bottom: 0;
                  color: #a3a4a6;
                  font-size: 14px;
                ">
                items per page
              </span>
            </div>
            <div class="d-flex align-items-center flex-wrap">
              <p class="mt-2 mb-2" style="
                  color: #a3a4a6;
                  margin-right: 20px;
                  margin-bottom: 0;
                ">
                Showing
                {{
                  (currentPage - 1) * limitPerPage + 1
                }}-{{ currentPage * limitPerPage < total ? currentPage * limitPerPage : total }} of {{ total > 0 ? total
                  : "?" }} Items
              </p>
              <nav class="pagination-minimal">
                <ul class="pagination" style="margin: 0; flex-wrap: wrap">
                  <li class="page-item" :class="{ disabled: currentPage <= 1 }"
                    @click.stop.prevent="changePage('prev')">
                    <a class="page-link" href="javascript:void(0)">&lsaquo;</a>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage >= maxPage && !hasMoreData }"
                    @click.stop.prevent="changePage('next')">
                    <a class="page-link" href="javascript:void(0)">&rsaquo;</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import moment from "moment";
import logDashActivity from "@/components/filter/logDashActivity";

export default {
  metaInfo: {
    title: "Log Dashboard Activity",
  },
  components: {
    logDashActivity,
  },
  data() {
    return {
      filter: {
        search: "",
      },
      appliedFilters: {},
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      maxPage: 1,
      total: 0,
      limitPerPage: 10,
      fetchDataTimer: null,
    };
  },
  computed: {
    hasMoreData() {
      return this.tableData.length === this.limitPerPage;
    },
  },
  watch: {
    "filter.search"(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.fetchData();
      }
    },
  },
  beforeDestroy() {
    if (this.fetchDataTimer) {
      clearTimeout(this.fetchDataTimer);
    }
  },
  methods: {
    changeFilter(filter) {
      const incomingFilter = filter || {};

      for (const key of Object.keys(incomingFilter)) {
        this.$set(this.filter, key, incomingFilter[key]);
      }

      const { search, ...rest } = incomingFilter;
      this.appliedFilters = { ...rest };

      this.currentPage = 1;
      this.fetchData(true);
    },
    onSearchClick() {
      this.currentPage = 1;
      this.fetchData(true);
    },
    fetchData(immediate = false) {
      if (this.fetchDataTimer) {
        clearTimeout(this.fetchDataTimer);
      }

      if (immediate) {
        this.performFetchData();
        return;
      }

      this.fetchDataTimer = setTimeout(() => {
        this.performFetchData();
      }, 300);
    },
    async performFetchData() {
      this.tableLoading = true;

      try {
        const baseParams = {
          pagination: true,
          limit: this.limitPerPage,
          page: this.currentPage,
          order: "DESC",
          by: "id",
        };

        if (this.filter.search && this.filter.search.trim()) {
          baseParams.search = this.filter.search.trim();
        }

        const combinedParams = {
          ...this.appliedFilters,
          ...baseParams,
        };

        const queryString = qs.stringify(combinedParams, {
          skipNulls: true,
          arrayFormat: "comma",
        });

        const url = `/api/log/get?${queryString}`;
        const resp = await this.$http.get(url);

        const rawData = (resp && resp.data && resp.data.data) || [];
        const processedData = rawData.map((item) => ({
          user_id: item.user_id || "-",
          username: item.username || "-",
          menu: item.menu || "-",
          module: item.module || "-",
          created_at: item.created_at ? this.formatDate(item.created_at) : "-",
        }));

        const meta =
          (resp && resp.data && resp.data.meta) ||
          (resp && resp.data && resp.data.pagination) ||
          (resp && resp.data) ||
          {};

        const pagination = this.normalizePagination(meta, processedData.length);

        this.$set(this, "tableData", processedData);
        this.$set(this, "currentPage", pagination.currentPage);
        this.$set(this, "maxPage", pagination.lastPage);
        this.$set(this, "total", pagination.total);
      } catch (err) {
        console.log("Error fetching log activity data:", err);
        this.$set(this, "tableData", []);
        this.$set(this, "currentPage", 1);
        this.$set(this, "maxPage", 1);
        this.$set(this, "total", 0);
      } finally {
        this.tableLoading = false;
      }
    },
    onLimitChange() {
      this.$set(this, "currentPage", 1);
      this.fetchData(true);
    },
    changePage(direction) {
      if (this.tableLoading) {
        return;
      }

      let newPage = this.currentPage;

      if (direction === "prev") {
        newPage = Math.max(1, this.currentPage - 1);
      } else if (direction === "next") {
        if (this.hasMoreData || this.currentPage < this.maxPage) {
          newPage = this.currentPage + 1;
        } else {
          return;
        }
      }

      if (newPage !== this.currentPage && newPage >= 1) {
        this.$set(this, "currentPage", newPage);
        this.fetchData(true);
      }
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD hh:mm:ss");
    },
    normalizePagination(meta, dataLength) {
      const currentPage =
        meta.currentPage ||
        meta.current_page ||
        meta.page ||
        this.currentPage ||
        1;

      const effectivePage = Number.parseInt(currentPage, 10);

      let total =
        meta.total ||
        meta.totalItems ||
        meta.total_count ||
        meta.totalRecords ||
        meta.count ||
        0;

      let lastPage =
        meta.lastPage ||
        meta.last_page ||
        meta.totalPages ||
        meta.total_pages ||
        meta.maxPage ||
        0;

      if (total === 0) {
        if (dataLength === this.limitPerPage) {
          total = effectivePage * this.limitPerPage;
          lastPage = effectivePage + 1;
        } else if (dataLength > 0) {
          total = (effectivePage - 1) * this.limitPerPage + dataLength;
          lastPage = effectivePage;
        } else {
          total = 0;
          lastPage = 1;
        }
      } else if (!lastPage || lastPage === 0) {
        lastPage = Math.ceil(total / this.limitPerPage);
      }

      lastPage = Math.max(1, lastPage);

      if (dataLength === this.limitPerPage && effectivePage >= lastPage) {
        lastPage = effectivePage + 1;
      }

      return {
        currentPage: effectivePage,
        total: Number.parseInt(total, 10),
        lastPage: Number.parseInt(lastPage, 10),
      };
    },
  },
};
</script>

<style scoped>
.innerBox {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #9f9f9f;
}

.box-content {
  padding: 20px;
  border-radius: 10px;
}

.table td,
.table th {
  text-align: left;
  vertical-align: middle;
}

.scan-history-table-wrapper .scan-history-table {
  border-collapse: separate;
  border-spacing: 0;
  border: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr {
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr {
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr:nth-of-type(odd) {
  background-color: #ffffff !important;
}

.scan-history-table-wrapper .scan-history-table thead th {
  color: #9d9d9d;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6;
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td {
  color: #4b4b4b;
  text-align: left;
  vertical-align: middle;
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:first-child td {
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:last-child td {
  border-bottom: none !important;
}

.scan-history-table-wrapper .pagination-minimal .pagination {
  margin-bottom: 0;
}

.scan-history-table-wrapper .pagination-minimal .page-item {
  margin: 0 2px;
}

.scan-history-table-wrapper .pagination-minimal .page-item .page-link {
  background: transparent !important;
  border: none !important;
  color: #4b4b4b;
  padding: 4px 8px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
}

.scan-history-table-wrapper .pagination-minimal .page-item:not(.disabled) .page-link:hover {
  background: transparent !important;
  color: #007bff;
}

.scan-history-table-wrapper .pagination-minimal .page-item.disabled .page-link {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.4;
  color: #9d9d9d !important;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link {
  background: transparent !important;
  border: none !important;
  color: #007bff !important;
  font-weight: 600;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link:hover {
  background: transparent !important;
  color: #007bff !important;
}
</style>